// Exports
export default {
	"nativeAppBanner": "nativeAppBanner_AwtYA",
	"appIcon": "appIcon_AFySl",
	"appDetails": "appDetails_qlDPn",
	"appName": "appName_+ZuYa",
	"appDescription": "appDescription_lM37T"
};
